import React, { memo, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  getOperatorMissionStatus,
  getMissionOperatorFleetIdForSubscribe,
  setMissionOperatorFleetId,
} from "Slices/operatorData";
import { getCurrentSemanticMap } from "Slices/semanticMaps";
import { getIsStopsByCurrentSemanticMapEmpty } from "Slices/stops";

import { ReactComponent as ConversionIcon } from "Components/common/assets/select-station-icon.svg";

import StationActions from "./components/StationActions/StationActions";
import { VehicleMissionStatus } from "./components/VehicleWayStatus/VehicleMissionStatus";

import StationPicker from "./components/Stations/StationPicker";
import SelectSemanticMap from "./components/Stations/SelectSemanticMap";

import {
  OperatorPanelWrapperStyled,
  OperatorInspectionStyled,
  SubtitleWrapperStyled,
  SemanticMapPickerStyled,
  EmptyErrorStyled,
} from "./styles";

export const OperatorPanel = memo(() => {
  const operatorMissionStatus = useSelector(getOperatorMissionStatus);
  const operatorFleetIdForSubscribe = useSelector(
    getMissionOperatorFleetIdForSubscribe
  );
  const isStopsEmpty = useSelector(getIsStopsByCurrentSemanticMapEmpty);
  const currentSemanticMap = useSelector(getCurrentSemanticMap);
  const dispatch = useDispatch();

  const handleSelectedFleet = useCallback((fleetId: string | null) => {
    dispatch(setMissionOperatorFleetId(fleetId));
  }, []);

  const initFleetId =
    operatorMissionStatus &&
    operatorMissionStatus !== "NO_MISSION" &&
    operatorFleetIdForSubscribe
      ? operatorFleetIdForSubscribe
      : "";

  return (
    <OperatorPanelWrapperStyled>
      {operatorMissionStatus && <VehicleMissionStatus />}
      <OperatorInspectionStyled>
        <SubtitleWrapperStyled>
          <ConversionIcon />
          <h3>{currentSemanticMap?.name ?? ""}</h3>
          <SemanticMapPickerStyled>
            <SelectSemanticMap />
          </SemanticMapPickerStyled>
        </SubtitleWrapperStyled>
        <StationPicker />
        {isStopsEmpty && (
          <EmptyErrorStyled>Error: no mission stations!</EmptyErrorStyled>
        )}
      </OperatorInspectionStyled>
      <StationActions
        initFleetId={initFleetId}
        isPickerDisabled={
          operatorMissionStatus && operatorMissionStatus !== "NO_MISSION"
        }
        handleSelectedFleet={handleSelectedFleet}
        shouldUseSavedFleet={true}
      />
    </OperatorPanelWrapperStyled>
  );
});
